const clSelects = [...document.querySelectorAll('.js-cl-select')];

clSelects.map(clSelect => {
    const items = [...clSelect.querySelectorAll('.js-cl-select-item')];

    items.map(item => {
        item.addEventListener('click', () => {
            window.location = item.getAttribute('data-url');
        })
    });

    clSelect.addEventListener('click', () => {
        clSelects.forEach(otherClSelect => {
            if (otherClSelect !== clSelect && otherClSelect.hasAttribute('data-active')) {
                otherClSelect.removeAttribute('data-active');
            }
        });

        if (clSelect.hasAttribute('data-active')) {
            clSelect.removeAttribute('data-active');
        } else {
            clSelect.setAttribute('data-active', '');
        }
    });
});

if (clSelects) {
    document.addEventListener('click', function (event) {
        const clSelects = [...document.querySelectorAll('.js-cl-select')];
        clSelects.map(clSelect => {
            if (!clSelect.contains(event.target)) {
                clSelect.removeAttribute('data-active');
            }
        });
    });
}
